import React from "react";
import { Popover, PopoverBody } from "reactstrap";
import T from "../translate";

const PasswordRequirements = ({ isOpen, target, placement }) => {
  return (
    <Popover
      placement={placement}
      isOpen={isOpen}
      target={target}
      hideArrow
      popperClassName="border-0 mb-3"
    >
      <PopoverBody className="arrow_box rounded">
        <h1 className="font-size-09 text-primary">
          <T i18nKey="contrasenaDebeCumplirSiguienteRequisitos" />:
        </h1>
        <ul className="pl-3 mb-0">
          <li>
            <T i18nKey="minimo8Caracteres" />
          </li>
          <li>
            <T i18nKey="minimoUnaMayuscula" />
          </li>
          <li>
            <T i18nKey="minimoUnNumero" />
          </li>
        </ul>
      </PopoverBody>
    </Popover>
  );
};

export default PasswordRequirements;
